export default __webpack_public_path__ + "static/media/title-deco-left.38c97b02.webp";